import React from 'react';
import { pure, compose } from 'recompose';
import RowWithTwo from './RowWithTwo.jsx';
import RowWithThree from './RowWithThree.jsx';
import InsiderAd from '../Ads/InsiderAd.jsx';
import _ from 'lodash';
import PopularVideos from './PopularVideos.jsx';

const ArticleList = ({ articles, children, additionalContent }) =>
  <div >
    { children }

    {children && <PopularVideos />}

    <RowWithTwo articles={articles.slice(0, 2)} />
    <RowWithThree articles={articles.slice(2, 5)} />

    {!children && <PopularVideos />}

    <RowWithThree articles={articles.slice(5, 8)} />

    { additionalContent }

    {
      _.map(_.chunk(articles.slice(8), 10), articleChunk =>
        [
          <RowWithTwo articles={articleChunk.slice(0, 2)} />,
          <RowWithTwo articles={articleChunk.slice(2, 4)} />,
          <RowWithThree articles={articleChunk.slice(4, 7)} />,
          <RowWithThree articles={articleChunk.slice(7, 10)} />,
          articleChunk.length === 10 ? <InsiderAd /> : null,
        ]
      )
    }

  </div>;

export default compose(pure)(ArticleList);



// WEBPACK FOOTER //
// ./src/component/NewsFeed/ArticleList.jsx